import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t bg-slate-50">
      <div className="container mx-auto px-4 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="mb-2 text-lg font-bold text-slate-900">financiallyfree.ro</h3>
            <p className="mb-4 text-sm text-slate-600">{t('footer.tagline')}</p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/financiallyfree.official"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 transition-colors hover:text-blue-600"
                data-testid="instagram-link"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.tiktok.com/@financiallyfree_official"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 transition-colors hover:text-blue-600"
                data-testid="tiktok-link"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-semibold text-slate-900">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="text-slate-600 hover:text-teal-600">
                  {t('nav.products')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-600 hover:text-teal-600">
                  {t('nav.blog')}
                </Link>
              </li>
              <li>
                <Link to="/tools" className="text-slate-600 hover:text-teal-600">
                  {t('nav.tools')}
                </Link>
              </li>
              <li>
                <Link to="/ai-money-mentor" className="text-slate-600 hover:text-teal-600">
                  {t('nav.aiMentor')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-600 hover:text-teal-600">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-4 font-semibold text-slate-900">{t('footer.legal')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/privacy-policy" className="text-slate-600 hover:text-teal-600">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-slate-600 hover:text-teal-600">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center text-sm text-slate-600">
          <p>© {new Date().getFullYear()} financiallyfree.ro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;